import { render, staticRenderFns } from "./PublishCalendar.vue?vue&type=template&id=5bbfab50&scoped=true"
import script from "./PublishCalendar.vue?vue&type=script&lang=js"
export * from "./PublishCalendar.vue?vue&type=script&lang=js"
import style0 from "./PublishCalendar.vue?vue&type=style&index=0&id=5bbfab50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfab50",
  null
  
)

export default component.exports